import { render, staticRenderFns } from "./TabelaAtualizarPrecos.vue?vue&type=template&id=4229905d&scoped=true&"
import script from "./TabelaAtualizarPrecos.vue?vue&type=script&lang=js&"
export * from "./TabelaAtualizarPrecos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAtualizarPrecos.vue?vue&type=style&index=0&id=4229905d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4229905d",
  null
  
)

export default component.exports